import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Pure Organic Cotton",
    text: "Single-origin mulmul and cambric from family looms around Bangalore — pre-washed thrice so it arrives cloud-soft and never shrinks on you.",
    img: "https://images.unsplash.com/photo-1566454544259-f4b94c3d758c?auto=format&fit=crop&w=800&q=80",
    alt: "Handwoven cotton dresses on a rack",
    bg: "bg-blush",
  },
  {
    num: "02",
    title: "Skin-Safe Natural Dyes",
    text: "Azo-free, paediatrician-reviewed dyes. Every batch is rub-tested and wash-tested, because little skin remembers everything.",
    img: "https://images.unsplash.com/photo-1653686932978-c8003098addc?auto=format&fit=crop&w=800&q=80",
    alt: "A little one twirling in a white dress",
    bg: "bg-mint",
  },
  {
    num: "03",
    title: "Tailored for High-Mobility Play",
    text: "Gusseted armholes, playground-proof seams, room-to-grow hems. Our dresses are engineered around cartwheels, not mannequins.",
    img: "https://images.unsplash.com/photo-1599624427857-461fd60c23e5?auto=format&fit=crop&w=800&q=80",
    alt: "Child playing on a grass field in a summer dress",
    bg: "bg-peach",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-20 md:py-28" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-14"
        >
          <p className="font-mono text-xs tracking-[0.35em] uppercase text-sage-dark mb-4">The Craft Manifesto</p>
          <h2 className="font-serif font-black text-3xl sm:text-4xl lg:text-5xl text-ink tracking-tight max-w-2xl leading-[1.1]">
            Three promises, stitched into every seam.
          </h2>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.num}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className={`${c.bg} rounded-[2rem] p-6 group`}
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <div className="flex items-start justify-between mb-6">
                <span className="font-mono font-bold text-5xl text-ink/15 group-hover:text-terracotta transition-colors duration-500">{c.num}</span>
                <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-charcoal/60 mt-2">Chapter</span>
              </div>
              <div className="overflow-hidden rounded-2xl mb-6">
                <img
                  src={c.img}
                  alt={c.alt}
                  loading="lazy"
                  className="w-full aspect-[16/10] object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
              </div>
              <h3 className="font-serif font-bold text-xl sm:text-2xl text-ink mb-3">{c.title}</h3>
              <p className="text-sm sm:text-base text-charcoal leading-relaxed">{c.text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
